var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { format } from 'date-fns';
import { enUS, th, vi } from 'date-fns/locale';
import { Platform } from 'react-native';
import { isProduction } from '../Constants';
import { IG_STORY_STEP3_EXAMPLE_PHOTOS, IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS, FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS, TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS, IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS, YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS, TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS, } from '../Constants/ExamplePhotos';
import { COUNTRY_ENUM } from '../Constants/CountryConfig';
export var PAYOUT_TYPE;
(function (PAYOUT_TYPE) {
    PAYOUT_TYPE["LIKE"] = "like";
    PAYOUT_TYPE["COMMENT"] = "comment";
    PAYOUT_TYPE["TAG"] = "tag";
    PAYOUT_TYPE["VIEW"] = "view";
    PAYOUT_TYPE["SHARE"] = "share";
    PAYOUT_TYPE["STICKER_TAP"] = "sticker_tap";
    PAYOUT_TYPE["IMPRESSION"] = "impression";
    PAYOUT_TYPE["REACH"] = "reach";
    PAYOUT_TYPE["CTA_CLICK"] = "cta_click";
    PAYOUT_TYPE["SAVE"] = "save";
    PAYOUT_TYPE["REPLY"] = "reply";
    PAYOUT_TYPE["RETWEET"] = "retweet";
    PAYOUT_TYPE["ENGAGEMENT"] = "engagement";
    PAYOUT_TYPE["LINK_CLICK"] = "link_click";
    PAYOUT_TYPE["BASE"] = "base";
    PAYOUT_TYPE["EXTRAS"] = "extras";
})(PAYOUT_TYPE || (PAYOUT_TYPE = {}));
export function dateToBackendFormat(date) {
    return date.toISOString().replace('Z', '+00:00');
}
export function isInRange(number, start, end) {
    if (start && end) {
        return number >= start && number <= end;
    }
    else if (start) {
        return number >= start;
    }
    else if (end) {
        return number <= end;
    }
    return false;
}
var NUMBER_SYMBOL = ['', 'k', 'M'];
var NUMBER_SYMBOL_ID = ['', 'k', 'jt'];
export function abbreviateNumber(value, country) {
    if (value === null || value === 0)
        return value;
    var tier = Math.floor(Math.log10(value) / 3);
    if (tier === 0)
        return value;
    var scale = Math.pow(10, tier * 3);
    return Math.floor(value / scale) + (country === COUNTRY_ENUM.ID ? NUMBER_SYMBOL_ID[tier] : NUMBER_SYMBOL[tier]);
}
export function isIOS() {
    return Platform.OS === 'ios';
}
export function isAndroid() {
    return Platform.OS === 'android';
}
export var sortByIndex = function (a, b, by) {
    if (by === void 0) { by = function (data) { return data.index; }; }
    return by(a) - by(b);
};
/*
    Currently we have defined 9 formats in Notion:
    https://www.notion.so/partipost/Date-time-handling-4504990ff5a046cc9f29f885d55b7921#48cd2eb570e24eb6b49153ce5ade0513
    if not match any format, default will use original format with en-US locale
*/
export var getCountryDateFormat = function (dateFormat, deviceLocale) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var getDateLocal = function () { var _a; return (((_a = deviceLocale.code) === null || _a === void 0 ? void 0 : _a.includes('zh')) ? enUS : deviceLocale); };
    switch (dateFormat) {
        case 'd MMM': {
            if ((_a = deviceLocale.code) === null || _a === void 0 ? void 0 : _a.includes('vi')) {
                return { dateFormat: 'd / M', locale: vi };
            }
            return { dateFormat: dateFormat, locale: getDateLocal() };
        }
        case 'dd MMM': {
            if ((_b = deviceLocale.code) === null || _b === void 0 ? void 0 : _b.includes('th')) {
                return { dateFormat: 'd MMM', locale: th };
            }
            else if ((_c = deviceLocale.code) === null || _c === void 0 ? void 0 : _c.includes('vi')) {
                return { dateFormat: 'd / M', locale: vi };
            }
            return { dateFormat: dateFormat, locale: getDateLocal() };
        }
        case 'd MMMM': {
            if ((_d = deviceLocale.code) === null || _d === void 0 ? void 0 : _d.includes('vi')) {
                return { dateFormat: "d 'tháng' M", locale: vi };
            }
            return { dateFormat: dateFormat, locale: getDateLocal() };
        }
        case 'd MMM yyyy': {
            if ((_e = deviceLocale.code) === null || _e === void 0 ? void 0 : _e.includes('vi')) {
                return { dateFormat: "d 'tháng' M yyyy", locale: vi };
            }
            return { dateFormat: dateFormat, locale: getDateLocal() };
        }
        case 'd MMM, yyyy': {
            if ((_f = deviceLocale.code) === null || _f === void 0 ? void 0 : _f.includes('th')) {
                return { dateFormat: 'd MMM yyyy', locale: th };
            }
            else if ((_g = deviceLocale.code) === null || _g === void 0 ? void 0 : _g.includes('vi')) {
                return { dateFormat: "d 'tháng' M, yyyy", locale: vi };
            }
            return { dateFormat: dateFormat, locale: getDateLocal() };
        }
        case 'dd MMM, yyyy': {
            if ((_h = deviceLocale.code) === null || _h === void 0 ? void 0 : _h.includes('th')) {
                return { dateFormat: 'd MMM yyyy', locale: th };
            }
            else if (deviceLocale && ((_j = deviceLocale.code) === null || _j === void 0 ? void 0 : _j.includes('vi'))) {
                return { dateFormat: "d 'tháng' M, yyyy", locale: vi };
            }
            return { dateFormat: dateFormat, locale: getDateLocal() };
        }
        case 'MMM d, yyyy h:mm a': {
            if ((_k = deviceLocale.code) === null || _k === void 0 ? void 0 : _k.includes('th')) {
                return { dateFormat: 'd MMM yyyy p', locale: th };
            }
            else if ((_l = deviceLocale.code) === null || _l === void 0 ? void 0 : _l.includes('vi')) {
                return { dateFormat: "d 'tháng' M, yyyy H:mm", locale: vi };
            }
            return { dateFormat: dateFormat, locale: getDateLocal() };
        }
        case 'iii d MMM, yyyy h:mm a': {
            if ((_m = deviceLocale.code) === null || _m === void 0 ? void 0 : _m.includes('th')) {
                return { dateFormat: 'iii d MMM yyyy p', locale: th };
            }
            else if ((_o = deviceLocale.code) === null || _o === void 0 ? void 0 : _o.includes('vi')) {
                return { dateFormat: "iii d, 'tháng' M, yyyy H:mm", locale: vi };
            }
            return { dateFormat: dateFormat, locale: getDateLocal() };
        }
        case 'h:mm a': {
            if ((_p = deviceLocale.code) === null || _p === void 0 ? void 0 : _p.includes('th')) {
                return { dateFormat: 'p', locale: th };
            }
            else if ((_q = deviceLocale.code) === null || _q === void 0 ? void 0 : _q.includes('vi')) {
                return { dateFormat: 'H:mm', locale: vi };
            }
            return { dateFormat: dateFormat, locale: getDateLocal() };
        }
        default: {
            return { dateFormat: dateFormat, locale: enUS };
        }
    }
};
export var formatDisplayDate = function (value, dateFormat, addSeconds, deviceLocale) {
    if (dateFormat === void 0) { dateFormat = 'd MMM yyyy'; }
    if (addSeconds === void 0) { addSeconds = 0; }
    if (value) {
        var date = new Date(value);
        date = new Date(date.getTime() + addSeconds * 1000);
        var transformedDateFormat = getCountryDateFormat(dateFormat, deviceLocale);
        return format(date, transformedDateFormat.dateFormat, { locale: transformedDateFormat.locale });
    }
    else {
        return new Date();
    }
};
export var formatAmountWithCurrency = function (currency, amount, locale, fullFormat, noSpace) {
    if (fullFormat === void 0) { fullFormat = false; }
    if (noSpace === void 0) { noSpace = false; }
    // Moved from backend
    var thousandChar = '';
    var options = {};
    var replace = /^(\D+)/;
    var replaceValue = '$1 ';
    if (currency === 'IDR') {
        locale = 'id';
        if (!fullFormat && amount > 1000) {
            amount = amount / 1000;
            thousandChar = 'K';
        }
        options = {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        };
        replaceValue = '$1';
    }
    else if (currency === 'TWD' || currency === 'HKD') {
        locale = 'zh';
    }
    else if (currency === 'PHP') {
        locale = 'fil';
    }
    else if (currency === 'MYR') {
        locale = 'ms';
        replace = /\s/g;
        replaceValue = '';
    }
    else if (currency === 'SGD') {
        locale = 'en-sg';
        replace = /^$/; // Matches nothing, no replacement effect
        replaceValue = '';
    }
    else if (currency === 'VND') {
        locale = 'vi';
    }
    else if (currency === 'THB') {
        locale = 'th';
    }
    else {
        replace = /^$/; // Matches nothing, no replacement effect
    }
    var formatResult = currency
        ? new Intl.NumberFormat(locale, __assign({ style: 'currency', currency: currency }, options))
            .format(amount)
            .replace(replace, replaceValue) + thousandChar
        : amount.toString();
    if (currency === 'THB' && formatResult && formatResult.length > 1) {
        var amountDisplay = formatResult.substring(2, formatResult.length);
        var dollarSign = formatResult.substring(0, 1);
        formatResult = noSpace ? amountDisplay + dollarSign : amountDisplay + ' ' + dollarSign;
    }
    return formatResult;
};
export var getDisplayInArray = function (items, array) {
    if (array) {
        var result_1 = [];
        items.map(function (item) {
            array.filter(function (arr) {
                if (arr.id === item) {
                    result_1.push(arr.type || arr.label || '');
                }
            });
        });
        return result_1.join(', ');
    }
    return null;
};
export var isAdditionalPayout = function (type) {
    switch (type) {
        case PAYOUT_TYPE.BASE:
        case PAYOUT_TYPE.VIEW:
        case PAYOUT_TYPE.LIKE:
        case PAYOUT_TYPE.REACH:
        case PAYOUT_TYPE.IMPRESSION:
        case PAYOUT_TYPE.COMMENT:
        case PAYOUT_TYPE.TAG:
        case PAYOUT_TYPE.SHARE:
        case PAYOUT_TYPE.STICKER_TAP:
        case PAYOUT_TYPE.LINK_CLICK:
        case PAYOUT_TYPE.CTA_CLICK:
        case PAYOUT_TYPE.SAVE:
        case PAYOUT_TYPE.REPLY:
        case PAYOUT_TYPE.RETWEET:
        case PAYOUT_TYPE.ENGAGEMENT:
            return false;
        default:
            return true;
    }
};
export var getIgStoryStep3ExamplePhoto = function (deviceLocale) {
    if (isProduction) {
        return deviceLocale.includes('id')
            ? IG_STORY_STEP3_EXAMPLE_PHOTOS.PRODUCTION.ID
            : deviceLocale.includes('zh')
                ? IG_STORY_STEP3_EXAMPLE_PHOTOS.PRODUCTION.TW
                : deviceLocale.includes('vi')
                    ? IG_STORY_STEP3_EXAMPLE_PHOTOS.PRODUCTION.VN
                    : deviceLocale.includes('th')
                        ? IG_STORY_STEP3_EXAMPLE_PHOTOS.PRODUCTION.TH
                        : IG_STORY_STEP3_EXAMPLE_PHOTOS.PRODUCTION.EN;
    }
    else {
        return deviceLocale.includes('id')
            ? IG_STORY_STEP3_EXAMPLE_PHOTOS.STAGING.ID
            : deviceLocale.includes('zh')
                ? IG_STORY_STEP3_EXAMPLE_PHOTOS.STAGING.TW
                : deviceLocale.includes('vi')
                    ? IG_STORY_STEP3_EXAMPLE_PHOTOS.STAGING.VN
                    : deviceLocale.includes('th')
                        ? IG_STORY_STEP3_EXAMPLE_PHOTOS.STAGING.TH
                        : IG_STORY_STEP3_EXAMPLE_PHOTOS.STAGING.EN;
    }
};
export var getIgPostEngagementStepExamplePhoto = function (deviceLocale) {
    if (isProduction) {
        return deviceLocale.includes('id')
            ? IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.ID
            : deviceLocale.includes('zh')
                ? IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TW
                : deviceLocale.includes('vi')
                    ? IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.VN
                    : deviceLocale.includes('th')
                        ? IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TH
                        : IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.EN;
    }
    else {
        return deviceLocale.includes('id')
            ? IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.ID
            : deviceLocale.includes('zh')
                ? IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TW
                : deviceLocale.includes('vi')
                    ? IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.VN
                    : deviceLocale.includes('th')
                        ? IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TH
                        : IG_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.EN;
    }
};
export var getFbPostEngagementStepExamplePhoto = function (deviceLocale) {
    if (isProduction) {
        return deviceLocale.includes('id')
            ? FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.ID
            : deviceLocale.includes('zh')
                ? FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TW
                : deviceLocale.includes('vi')
                    ? FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.VN
                    : deviceLocale.includes('th')
                        ? FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TH
                        : FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.EN;
    }
    else {
        return deviceLocale.includes('id')
            ? FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.ID
            : deviceLocale.includes('zh')
                ? FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TW
                : deviceLocale.includes('vi')
                    ? FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.VN
                    : deviceLocale.includes('th')
                        ? FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TH
                        : FB_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.EN;
    }
};
export var getTiktokPostEngagementStepExamplePhoto = function (deviceLocale) {
    if (isProduction) {
        return deviceLocale.includes('id')
            ? TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.ID
            : deviceLocale.includes('zh')
                ? TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TW
                : deviceLocale.includes('vi')
                    ? TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.VN
                    : deviceLocale.includes('th')
                        ? TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TH
                        : TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.EN;
    }
    else {
        return deviceLocale.includes('id')
            ? TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.ID
            : deviceLocale.includes('zh')
                ? TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TW
                : deviceLocale.includes('vi')
                    ? TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.VN
                    : deviceLocale.includes('th')
                        ? TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TH
                        : TIKTOK_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.EN;
    }
};
export var getIgReelEngagementStepExamplePhoto = function (deviceLocale) {
    if (isProduction) {
        return deviceLocale.includes('id')
            ? IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.ID
            : deviceLocale.includes('zh')
                ? IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TW
                : deviceLocale.includes('vi')
                    ? IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.VN
                    : deviceLocale.includes('th')
                        ? IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TH
                        : IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.EN;
    }
    else {
        return deviceLocale.includes('id')
            ? IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.ID
            : deviceLocale.includes('zh')
                ? IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TW
                : deviceLocale.includes('vi')
                    ? IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.VN
                    : deviceLocale.includes('th')
                        ? IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TH
                        : IG_REEL_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.EN;
    }
};
export var getTwitterPostEngagementStepExamplePhoto = function (deviceLocale) {
    if (isProduction) {
        return deviceLocale.includes('id')
            ? TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.ID
            : deviceLocale.includes('zh')
                ? TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TW
                : deviceLocale.includes('vi')
                    ? TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.VN
                    : deviceLocale.includes('th')
                        ? TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TH
                        : TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.EN;
    }
    else {
        return deviceLocale.includes('id')
            ? TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.ID
            : deviceLocale.includes('zh')
                ? TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TW
                : deviceLocale.includes('vi')
                    ? TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.VN
                    : deviceLocale.includes('th')
                        ? TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TH
                        : TWITTER_POST_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.EN;
    }
};
export var getYoutubeVideoEngagementStepExamplePhoto = function (deviceLocale) {
    if (isProduction) {
        return deviceLocale.includes('id')
            ? YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.ID
            : deviceLocale.includes('zh')
                ? YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TW
                : deviceLocale.includes('vi')
                    ? YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.VN
                    : deviceLocale.includes('th')
                        ? YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.TH
                        : YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.PRODUCTION.EN;
    }
    else {
        return deviceLocale.includes('id')
            ? YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.ID
            : deviceLocale.includes('zh')
                ? YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TW
                : deviceLocale.includes('vi')
                    ? YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.VN
                    : deviceLocale.includes('th')
                        ? YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.TH
                        : YOUTUBE_VIDEO_ENGAGEMENT_STEP_EXAMPLE_PHOTOS.STAGING.EN;
    }
};
export var getOthersEngagementStepExamplePhoto = function () {
    // TODO: update example photo here
    return [];
};
// validate number input, only number character
export var isValidNumberInput = function (value) {
    var numberPattern = /^\d+$/;
    return numberPattern.test(value);
};
